//constants
import {TICKETS_INFO, PAYMENT, ATTENDEES_INFO} from '@/utils/constants';
//form configuration
import {AddTableTicketFormValues} from './formConfiguration';

export const addTableTicketSteps = [`1. ${TICKETS_INFO}`, `2. ${PAYMENT}`, `3. ${ATTENDEES_INFO}`];

export enum ADD_TABLE_TICKET_STEP {
	TICKET_INFO,
	PAYMENT,
	ATTENDEES_INFO,
}

export const getNewTableTicketValues = (tableAndTicketValues: AddTableTicketFormValues, organizationId: number) => {
	const newValues: AddTableTicketFormValues = {
		...tableAndTicketValues,
		creatorId: +organizationId,
		purchaser: {...tableAndTicketValues.purchaser, phoneNumber: String(tableAndTicketValues.purchaser.phoneNumber)},
		setTables: tableAndTicketValues.setTables.map(({purchaserIsNotAttending, ...table}) => ({
			...table,
			attendees: table.attendees.map(({meals, phoneNumber, ...attendee}) => ({
				...attendee,
				phoneNumber: String(phoneNumber),
				meals,
			})),
		})),
	};

	return newValues;
};
